import { api } from "./api";

export interface SubscriptionStatus {
  plan: string;
  trial_ends_at: string | null;
  cancel_at_period_end: boolean;
  current_period_end: string | null;
  payment_status: string;
}

export interface CheckoutSessionResponse {
  url: string;
}

export interface PortalSessionResponse {
  url: string;
}

export const subscriptionApi = api.injectEndpoints({
  endpoints: (build) => ({
    getSubscriptionStatus: build.query<SubscriptionStatus, void>({
      query: () => ({ url: "company/subscription" }),
      providesTags: ["Subscription"],
    }),
    createCheckoutSession: build.mutation<CheckoutSessionResponse, { plan: "pro" | "growth" }>({
      query: (body) => ({
        url: "subscription/checkout-session",
        method: "POST",
        body,
      }),
    }),
    createPortalSession: build.mutation<PortalSessionResponse, void>({
      query: () => ({
        url: "subscription/portal-session",
        method: "POST",
      }),
    }),
  }),
});

export const {
  useGetSubscriptionStatusQuery,
  useLazyGetSubscriptionStatusQuery,
  useCreateCheckoutSessionMutation,
  useCreatePortalSessionMutation,
} = subscriptionApi;